/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Prowoche1Inputs */

const de__field_prowoche1 = /** @type {(inputs: _Field_Prowoche1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Woche`)
};

/**

* @param {_Field_Prowoche1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_prowoche1 = /** @type {((inputs?: _Field_Prowoche1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Prowoche1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_prowoche1(inputs)
});
export { _field_prowoche1 as "_field_proWoche" }